import $ from 'jquery'

const debug = require('debug')('pm:remote-dropdown')

$(function loadRemoteDropdowns() {
  const $dropdowns = $('.js-remote-dropdown')

  $dropdowns.on('click', function loadDropdownContent() {
    debug('loadDropdownContent()')

    const $dropdown = $($(this).data('dropdown-target'))
    const url = $(this).data('url')

    if ($dropdown.data('loaded')) return

    $dropdown.addClass('u-is-loading')

    $.get(url)
      .done(response => {
        $dropdown.data('loaded', true).html(response)
      })
      .fail(() => {
        $dropdown.html(
          '<div class="dropdown_list-error">The dropdown failed to load. 😢</div>'
        )
      })
      .always(() => {
        $dropdown.removeClass('u-is-loading')
      })
  })
})
